<template>
    <div class="p-grid news-page">
        <div class="p-col-6">
            <div class="card news-form">
                <h2>Add news</h2>
                <div class="form-item">
                    <label for="summery">News summary</label>
                    <InputText id="summery" type="text" v-model="info" />
                </div>
                <div class="form-item form-item-text">
                    <label for="news-text">Complete news</label>
                    <Editor id="news-text" v-model="rich" editorStyle="height: 182px">
                        <template slot="toolbar">
                            <span class="ql-formats">
                                <button class="ql-image" v-tooltip.bottom="'Image'"></button>
                                <button class="ql-link" v-tooltip.bottom="'Link'"></button>
                                <button class="ql-bold" v-tooltip.bottom="'Bold'"></button>
                                <button class="ql-italic" v-tooltip.bottom="'Italic'"></button>
                                <button class="ql-underline" v-tooltip.bottom="'Underline'"></button>

                            </span>
                        </template>
                    </Editor>
                </div>
                <div class="form-actions">
                    <Button @click="saveNews()" class="save" label="Save as new entry" style="margin:10px" />
                    <Button @click="updateNews()" class="update" label="Update" style="margin:10px" />
                    <Button @click="deleteNews()" class="delete" icon="icon icon-bin" style="margin:10px" />
                </div>
            </div>
        </div>
        <div class="p-col-6 data-table data-table-news">
            <div class="card news-list" style="word-break: normal">
                <h2>Recent News</h2>
                <DataTable :value="dataTableNews" class="p-datatable-responsive" :selection.sync="dataTableSelectedNews" selectionMode="none" dataKey="time" :autoLayout="true">
                    <Column field="news_time" header="Time" headerStyle="width: 120px" :sortable="false">
                        <template #body="slotProps">
                            <span class="time" style="word-spacing: 80px;">{{ formatDate(slotProps.data.news_time) }}</span>
                        </template>
                    </Column>
                    <Column field="info" header="Info" :sortable="false">
                        <template #body="slotProps">
                            <span class="info">{{slotProps.data.info }}</span>
                        </template>
                    </Column>
                    <Column header="Option" :sortable="false">
                        <template #body="slotProps">
                            <Button label="LOAD" icon="icon icon-plus" @click="loadNews(slotProps.data.id)" />
                        </template>
                    </Column>
                </DataTable>
            </div>
        </div>
    </div>
</template>

<script>

    import NewsService from '../../service/NewsService';

    export default {
        data() {
            return {
                rich: '',
                info: '',
                id: 0,
                dataTableNews: null,
                dataTableSelectedNews: null,


            }
        },
        created() {
            this.$store.commit('setPageTitle', {pageTitle: 'News'});
            this.newsService = new NewsService();
        },
        async mounted() {
            this.getNews();
        },
        methods: {
            async saveNews() {

                //console.log(this.rich);
                await this.newsService.saveNews(this.info, this.rich);
                this.getNews();

            },
            async deleteNews() {

                //console.log(this.rich);
                await this.newsService.deleteNews(this.id);
                this.getNews();

            },
            async updateNews() {

                //console.log(this.rich);
                await this.newsService.updateNews(this.info, this.rich, this.id);
                this.getNews();

            },
            async getNews() {
                this.dataTableNews = await this.newsService.getNews(5);
            },
            async loadNews(_id) {
                this.id = _id;

                var temp = await this.newsService.loadNews(this.id);

                this.info = temp.info;
                this.news_time = temp.news_time;
                this.rich = temp.rich;

            },

       
            formatDate(date) {
                var d = new Date(date),
                    month = "" + (d.getMonth() + 1),
                    day = "" + d.getDate(),
                    year = d.getFullYear(),
                    hours = "" + d.getHours(),
                    mins = "" + d.getMinutes();

                if (month.length < 2) month = "0" + month;
                if (day.length < 2) day = "0" + day;
                if (hours.length < 2) hours = "0" + hours;
                if (mins.length < 2) mins = "0" + mins;

                return hours + ":" + mins + " " + [year, month, day].join("/");
            },
        }


    }

</script>

<style scoped>
</style>